

import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: "f116350d-b636-4765-bfb2-ba333657bc1b",
        // clientId: "9f208562-df39-e6f7-876b-c99abed2610a",
        // clientId: "c473d950-8602-e725-96c4-b35a4fece91b", // personal env
        authority: "https://login.microsoftonline.com/organizations/",
        redirectUri: "https://qa.friday-report.com/"
    }, 
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true // Useful for older browsers
    },
    system: {
        /**
         * Below you can configure MSAL.js logs. For more information, visit:
         * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
         */
    },
};

export const pca = new PublicClientApplication(msalConfig);